{
    "accept": "Akzeptéieren",
    "action_open_in_external_app": "Opmaachen an ${1}",
    "back": "Zréck",
    "cancel": "Ofbriechen",
    "choose": "Wielt",
    "content_missing": "Den Inhalt fehlt.",
    "delete": "Läschen",
    "description": "Beschreiwung",
    "dismiss": "Verwerfen",
    "done": "Gemaach",
    "donor_feedback_anonymized": "Mir hunn Är Donnéeë schonn aus Dateschutzgrënn anonymiséiert.",
    "donor_feedback_incorrect_link": "De Link deen Dir benotzt ass net richteg. W.e.g stellt secher, datt Dir de komplette Link benotzt, deen Dir geschéckt krut",
    "donor_feedback_not_found": "Leider ass dëse Link ongëlteg, dëst kann ee vun de follgende Grënn hunn:",
    "error_occurred": "E Feeler ass opgetrueden",
    "expired": "Ofgelaaf",
    "failed": "Net bestan",
    "field_error_address_unsupported_country": "D'Adress ass net an engem akzeptéierte Land. ",
    "field_error_any": "Gitt w.e.g. op d'mannst ee vun dëse Felder un: ${1}",
    "field_error_date_invalid": "Gitt weg e gültege Datum un",
    "field_error_date_max": "Den Datum muss ${1} oder virdrun sinn",
    "field_error_date_min": "Den Datum muss ${1} oder duerno sinn",
    "field_error_date_range_max": "Den Datum muss virum ${1} sinn",
    "field_error_date_range_min": "Den Datum muss nom ${1} sinn",
    "field_error_email": "Gitt weg eng valabel E-Mail un",
    "field_error_length_max": "Dëst Feld ass limitéiert op ${1} Zeechen",
    "field_error_length_min": "Gitt w.e.g. e Minimum vun ${1} Zeechen an",
    "field_error_max": "De maximale Wäert ass ${1}",
    "field_error_min": "De minimale Wäert ass ${1}",
    "field_error_pattern": "Den Input ass ongülteg",
    "field_error_phone_invalid": "Gitt weg eng valabel Telefonsnummer an",
    "field_error_phone_starts_with_zero": "De Landcode gëtt et schonn. Ewechzehuelen de féierende \"0\" vun der Telefonsnummer.",
    "field_error_required": "Fëllt w.e.g. dëst Feld aus",
    "field_is_required": "Dëst Feld ass erfuerderlech",
    "field_placeholder_address_search": "Gëff w.e.g. eng Location an",
    "field_select_not_found": "'${1}' konnt net fonnt ginn",
    "font_big": "grouss Schrëft",
    "font_medium": "mëttel Schrëft",
    "font_small": "kleng Schrëft",
    "last_attempt": "Leschte Versuch",
    "last_upload": "Läschten Upload",
    "link_sent": "Link geschéckt, w.e.g kontrolléieren",
    "network_error": "Netzfehler",
    "next": "Weider",
    "no_results": "Keng Resultater",
    "offline": "offline",
    "ok": "ok",
    "online": "online",
    "open": "Opmaachen ",
    "page_not_found_description": "D'Säit wous du wollts opruffen, gëtt et net. Hues du dech bei der URL vertippt?",
    "page_not_found_link": "Zréck op d'Homepage.",
    "page_not_found_title": "Säit net fonnt",
    "passed": "Bestan",
    "result": "Resultat",
    "retry": "Nach eng Kéier probéieren",
    "save": "Späicheren",
    "state_done": "Gemaach",
    "state_not_uploaded": "Net eropgelueden",
    "state_pending": "En attente",
    "state_refused": "Refuséiert",
    "state_uploading": "Eroplueden",
    "submit": "Ofginn",
    "type": "Typ",
    "uploading": "Eroplueden..."
}